/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose } from 'recompose'
import { connect } from 'react-redux'
import { setLanguage } from 'redux-app/modules/localization'
import { getLang, isTextsLoading } from 'redux-app/selectors/localization'
import { getUserRole } from 'redux-app/selectors/auth'
import { getLanguageOptions } from 'redux-app/selectors/apiData'
import HeaderActions from './HeaderActions'

export default compose(
  connect(
    state => ({
      activeLang: getLang(state),
      isUserControlsVisible: !!getUserRole(state),
      languageOptions: getLanguageOptions(state),
      isTextsLoading: isTextsLoading(state),
    }),
    {
      setLanguage,
    },
  ),
)(HeaderActions)
